import { render, staticRenderFns } from "./InsulinUsageStatisticsTable1.vue?vue&type=template&id=3aff5040&scoped=true"
import script from "./InsulinUsageStatisticsTable1.vue?vue&type=script&lang=js"
export * from "./InsulinUsageStatisticsTable1.vue?vue&type=script&lang=js"
import style0 from "./InsulinUsageStatisticsTable1.vue?vue&type=style&index=0&id=3aff5040&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aff5040",
  null
  
)

export default component.exports